var shvenergy = shvenergy || {};

shvenergy.stickycta = (function ($) {
	'use strict';

	// /sitecore/content/Global settings/RenderingParameters/StickyCta/Triggers
	const EntryIntent = {
		TRIGGER_ON_LOAD: 'trigger-on-page-load',
		TRIGGER_ON_EXIT: 'trigger-on-page-intent',
		TRIGGER_ON_SCROLL: 'trigger-on-scroll',
	};

	const ctaRoot = $('[data-sticky-cta]');
	const pageHasStickyCta = ctaRoot.length > 0;

	// This has nothing to do with this element,
	// however we are not allowed to show this element if there is a quote retrieval form on the page
	const quoteRetrivalBlock = $('.quote-retrieval:not([hidden])');
	const pageHasQuoteRetrievalBlock = quoteRetrivalBlock.length > 0;

	if (!pageHasStickyCta || pageHasQuoteRetrievalBlock) {
		return;
	}

	const fetchSchedule = () => new Promise((resolve) => {
		if (!pageHasStickyCta) return resolve(false);

		const url = $(ctaRoot).data('activeapi');
		const PageId = $(ctaRoot).data('activepageid');

		$.post({ url, contentType: 'application/json' }, JSON.stringify({ PageId }))
			.done((data) => {
				resolve(data.IsActive);
			})
			.fail(() => resolve(false));
	});

	const createCTAHandler = (ctaConfig) => {
		const {
			visibleClass,
		} = ctaConfig;

		let ctaDuration = Number($(ctaRoot).data('duration') || 0) * 1000;
		if (isNaN(ctaDuration)) ctaDuration = 0;

		let timer;
		let onHideHandlers = [];
		let onShowHandlers = [];
		let shouldShowAgain = true;

		const fetchSchedulePromise = fetchSchedule();

		return {
			get visible() {
				return $(ctaRoot).hasClass(visibleClass);
			},
			show() {
				if (!this.visible && shouldShowAgain) {
					fetchSchedulePromise.then(isActive => {
						if (!isActive) return;

						$(ctaRoot).addClass(visibleClass);

						if (ctaDuration > 0) {
							timer = setTimeout(() => {
								this.hide();
							}, ctaDuration);
						}
						onShowHandlers.forEach(fn => fn());
					});
				}
			},
			hide() {
				if (this.visible) {
					if (timer) clearTimeout(timer);
					$(ctaRoot).removeClass(visibleClass);
					shouldShowAgain = false;

					onHideHandlers.forEach(fn => fn());
				}
			},
			/**
			 * @param {'hide' | 'show'} event 
			 * @param {Function} fn 
			 */
			on(event, fn) {
				if (event === 'show') {
					onShowHandlers.push(fn);
				}
				if (event === 'hide') {
					onHideHandlers.push(fn);
				}
			},
			/**
			 * @param {'hide' | 'show'} event 
			 * @param {Function} fn 
			 */
			off(event, fn) {
				if (event === 'show') {
					onShowHandlers = onShowHandlers.filter(h => h !== fn);
				}
				if (event === 'hide') {
					onHideHandlers = onHideHandlers.filter(h => h !== fn);
				}
			}
		};
	};

	const isLargeCTA = $(ctaRoot).hasClass('sticky-cta-v2');

	const ctaHandler = isLargeCTA
		? createCTAHandler({
			visibleClass: 'sticky-cta-v2--visible',
		})
		: createCTAHandler({
			visibleClass: 'isVisible'
		});

	const triggerOnScroll = () => {
		const ctaTriggerDiv = document.querySelector('div[data-cta-trigger]');

		const divIntersectionObserver = new IntersectionObserver(entries => {
			if (entries.some(entry => entry.isIntersecting)) {
				ctaHandler.show();
			}
		}, {
			rootMargin: '0px',
			threshold: 0.1,
		});

		return {
			init() {
				if (!ctaTriggerDiv) return;

				ctaHandler.on('hide', () => {
					divIntersectionObserver.unobserve(ctaTriggerDiv);
				});

				divIntersectionObserver.observe(ctaTriggerDiv);
			}
		}
	}

	const triggerOnPageLoad = () => ({
		init() {
			ctaHandler.show();
		}
	});

	const triggerOnExitIntent = () => {
		const mediaQueryList = window.matchMedia(
			`(max-width: ${shvenergy.utils.breakpointsObj.medium}px)`
		);

		const desktopIntentListener = (handler) => {
			document.addEventListener('mouseleave', handler);

			return () => {
				document.removeEventListener('mouseleave', handler);
			};
		};

		const mobileIntentListener = (handler) => {
			let previousScrollPosition = window.scrollY;
			let currentScrollPosition = window.scrollY;
			let threshold = Number.NEGATIVE_INFINITY;

			const triggerHandler = () => {
				const isScrollingDown = previousScrollPosition < currentScrollPosition;

				if (isScrollingDown && currentScrollPosition >= 200) {
					const currentThreshold = Math.max(0, currentScrollPosition - 700);
					if (currentThreshold > threshold) {
						threshold = currentThreshold;
					}
				}

				if (!isScrollingDown && currentScrollPosition <= threshold) {
					handler();
				}

				previousScrollPosition = currentScrollPosition;
			}

			const onScroll = (e) => {
				currentScrollPosition = window.scrollY;

				triggerHandler();
			}

			document.addEventListener('scroll', onScroll);
			triggerHandler();

			return () => {
				document.removeEventListener('scroll', onScroll);
			}
		};

		let previousMatch;
		let unsubscribe;
		const registerListener = (isMobile) => {
			if (isMobile === previousMatch) return;

			previousMatch = isMobile;

			if (unsubscribe) unsubscribe();

			const listener = isMobile ? mobileIntentListener : desktopIntentListener;

			unsubscribe = listener(() => {
				ctaHandler.show();
			})
		};

		return {
			init() {
				registerListener(mediaQueryList.matches);
				mediaQueryList.addEventListener('change', (e) => {
					registerListener(e.matches);
				})
			}
		}
	}

	const getEntryIntent = () => {
		const intent = $(ctaRoot).data('ctatrigger') || EntryIntent.TRIGGER_ON_LOAD;

		switch (intent) {
			case EntryIntent.TRIGGER_ON_LOAD: {
				return triggerOnPageLoad();
			}
			case EntryIntent.TRIGGER_ON_EXIT: {
				return triggerOnExitIntent();
			}
			case EntryIntent.TRIGGER_ON_SCROLL: {
				return triggerOnScroll();
			}
			default: {
				return {
					init() { } // do nothing
				}
			}
		}
	}

	$(function () {
		const entryIntent = getEntryIntent();
		entryIntent.init();

		$(ctaRoot).find('[data-sticky-cta-close]').on('click', function () {
			ctaHandler.hide();
		});
	});
})(jQuery);
